import { $, $$ } from './../helpers/qsa'

const menu = $('.masthead__menu')
const toggle = $('.masthead__menu-toggle')

toggle.addEventListener('click', () => document.body.classList.toggle('menu-is-active'))
